import PrivatePagesWrapper from "components/PrivatePagesWrapper/PrivatePagesWrapper";
import { PCardsTitles } from "libs/raas-ui-react-components/src/components";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  dateFormatter,
  getCards,
  getMyDocumentsLiterals,
} from "./MyDocuments.util";
import {
  getTokenVeridasCall,
  setSaveDocumentsCall,
} from "./MyDocuments.service";
import useToast from "hooks/useToast";
import { IToken } from "./MyDocuments.model";
import useSession from "hooks/useSession";
import "./MyDocuments.scss";
import {
  getUserDetail,
  setUserDetail,
} from "services/user/user.session.service";
import { getUserData } from "services/user/user-micros.service";
import { useNavigate } from "react-router-dom";

export const MyDocuments = () => {
  let raasUserDetail = getUserDetail().docs;
  const { openToast } = useToast();
  const [t] = useTranslation("privateHome");
  const titlesLiterals = getMyDocumentsLiterals(t);
  const [cardsLiterals, setCardsLiterals] = useState(null as any);
  const { setTokenVeridas, tokenVeridas } = useSession(); // Obtención del token del usuario
  const [showIframe, setShowIframe] = useState(false);
  const [statusVeridas, setStatusVeridas] = useState("");
  const [codeStatusVeridas, setCodeStatusVeridas] = useState("");
  const navigate = useNavigate();

  const handleNavigationCards = (e: any) => {
    setShowIframe(true); // Levanta el iframe cuando id es "doi"
  };

  let urlVeridas = "";
  useEffect(() => {
    if (tokenVeridas !== null && statusVeridas === "ok") {
      let body = {
        validation_id: tokenVeridas.validation_id,
        status: statusVeridas,
      };

      setSaveDocumentsCall(
        body,
        (response: any) => {
          getUserData(
            (response: any) => {
              const userDataResponse = response?.data;
              setUserDetail(userDataResponse);
              getDocumentsCards(userDataResponse.docs);
              getTokenVeridas();
              setShowIframe(false);
              if (window.location.search === "?goTo=/trip") {
                navigate("/trip");
              }
            },
            () => {
              openToast(
                "error",
                t("literals.error"),
                t("literals.errorTryAgainLater")
              );
            }
          );
        },
        (err: any) => {
          openToast(
            "error",
            t("literals.error"),
            t("literals.errorSaveVeridas")
          );
        }
      );
    } else if (statusVeridas === "ko") {
      setShowIframe(false);
      //getTokenVeridas();
      openToast("error", t("literals.error"), t("literals.errorTypeDocument"));
    } else if (statusVeridas === "ProcessCancelled") {
      setShowIframe(false);
    }
  }, [statusVeridas === "ok" || statusVeridas === "ko"]);

  useEffect(() => {
    if (window?.location?.href?.includes("https://www.docomobility.com/app/")) {
      urlVeridas = "https://xpressid-web.eu.veri-das.com/v2/?access_token=";
    } else {
      urlVeridas =
        "https://xpressid-web-work.eu.veri-das.com/v2/?access_token=";
    }
    getDocumentsCards(raasUserDetail);
    getTokenVeridas();
  }, [t]);

  useEffect(() => {
    const handleMessage = (event: any) => {
      // Aquí se maneja el mensaje recibido desde el iFrame
      if (event.origin === "https://xpressid-web.eu.veri-das.com" || event.origin === "https://xpressid-web-work.eu.veri-das.com") {
        let status = "";

        switch (event.data.code) {
          case "QRProcessCompleted":
          case "ProcessCompleted":
            status = "ok";
            break;
          case "QRProcessOnboardingError":
          case "UnknownDocumentTypeError":
          case "error":
            status = "ko";
            setCodeStatusVeridas(event.data.code);
            break;
          case "QRProcessCancelled":
          case "ProcessCancelled":
            status = "ProcessCancelled";
            break;
          case "ProcessEvents":
            if (event.data.infoEvent.code === "QRProcessCompleted") {
              status = "ok";
            } else {
              status = "process";
            }

            break;
          default:
            break;
        }
        setStatusVeridas(status);
      }
    };

    // Añadir el listener de mensajes
    window.addEventListener("message", handleMessage);

    return () => {
      // Remover el listener al desmontar el componente
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const getDocumentsCards = (data: any) => {
    let tarjetas = getCards(t);
    const result = tarjetas?.map((card: any) => {
      let filter = data.find((item: any) => item.type === card.id);
      return {
        ...card,
        ...(filter
          ? {
              descriptionText:
                filter.isExpired === false
                  ? t("literals.validated") + dateFormatter(filter.creationDate)
                  : t("literals.lapsed") + dateFormatter(filter.expirationDate),
            }
          : { descriptionText: "" }),
        iconType:
          filter != undefined
            ? filter.isExpired === false
              ? "checkSuccess"
              : "checkError"
            : "checkError",
        active:
          filter != undefined
            ? filter.isExpired === false
              ? false
              : true
            : true,
      };
    });
    setCardsLiterals(result);
  };

  const getTokenVeridas = () => {
    getTokenVeridasCall(
      (response: IToken) => {
        setTokenVeridas(response);
      },
      (err: any) => {
        openToast(
          "error",
          t("literals.errorTryAgainLater"),
          `${err?.status ? ":" + err?.status : ""} ${err?.statusText}`
        );
      }
    );
  };

  return (
    <>
      <PCardsTitles
        onNavigationCards={(e) => {
          handleNavigationCards(e.detail);
        }}
        literals={titlesLiterals}
        cards={cardsLiterals}
        variant="veridas"
      >
        <div slot="veridas">
          {showIframe &&
            tokenVeridas?.access_token !== null && ( // Renderiza el iframe solo si showIframe es verdadero
              <iframe
                id="XpressID-iframe"
                allow="camera; microphone; geolocation;"
                style={{ width: "500px", height: "500px", border: "none" }} // Añadir estilos para el iframe
                src={
                  (window?.location?.href?.includes(
                    "https://www.docomobility.com/app/"
                  )
                    ? "https://xpressid-web.eu.veri-das.com/v2/?access_token="
                    : "https://xpressid-web-work.eu.veri-das.com/v2/?access_token=") +
                  tokenVeridas?.access_token
                }
              ></iframe>
            )}
        </div>
      </PCardsTitles>

      <PrivatePagesWrapper />
    </>
  );
};
